import { CompanyIntegrationProviderEnum, GetAllIntegrationsStatusResponseData } from "schema"
import z from "zod"

type IntegrationStatus = z.infer<typeof GetAllIntegrationsStatusResponseData>
type IntegrationStatusKey = Exclude<keyof IntegrationStatus, "enabled">
type Provider = z.infer<typeof CompanyIntegrationProviderEnum>

function getProviderIntegrationKey(provider: Provider): IntegrationStatusKey | null {
  switch (provider) {
    case "Shopify":
      return "shopify"
    case "BigBlue":
      return "bigblue"
    case "Reveni":
      return "reveni"
    case "Amphora":
      return "amphora"
    case "LoopReturns":
      return "loopReturns"
    case "Rever":
      return "rever"
  }
}

export function isProviderEnabled(
  provider: Provider,
  integrationsStatus: IntegrationStatus | undefined,
): boolean {
  const key = getProviderIntegrationKey(provider)
  if (!key) return false
  return !!integrationsStatus?.[key] && integrationsStatus.enabled[key]
}

export function getProviderOptionKey(provider: Provider) {
  switch (provider) {
    case "Shopify":
      return "shopify"
    case "BigBlue":
      return "bigBlue"
    case "Reveni":
      return "reveni"
    case "Amphora":
      return "amphora"
    case "LoopReturns":
      return "loopReturns"
    case "Rever":
      return "rever"
  }
}
